import { render, staticRenderFns } from "./LearningDataTab.vue?vue&type=template&id=16394738&scoped=true"
import script from "./LearningDataTab.vue?vue&type=script&lang=js"
export * from "./LearningDataTab.vue?vue&type=script&lang=js"
import style0 from "./LearningDataTab.vue?vue&type=style&index=0&id=16394738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16394738",
  null
  
)

export default component.exports